/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CancelIcon = ({ width = 24, height = 24, hidden = false, title = 'Cancel' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M16.20123,16.16553c1.57397-1.58289,2.54877-3.76221,2.54877-6.16553,0-4.82471-3.92529-8.75-8.75-8.75-2.40332,0-4.58264.97485-6.16559,2.54883-.00647.00598-.01508.00781-.02142.01416s-.00818.01489-.01422.02148c-1.57397,1.58289-2.54877,3.76221-2.54877,6.16553,0,4.82471,3.92529,8.75,8.75,8.75,2.40332,0,4.58264-.97485,6.16559-2.54883.00647-.00598.01508-.00781.02142-.01416s.00818-.01489.01422-.02148ZM17.25,10c0,1.72925-.61047,3.31738-1.62463,4.56482L5.43518,4.37463c1.24744-1.01416,2.83563-1.62463,4.56482-1.62463,3.99756,0,7.25,3.25244,7.25,7.25ZM2.75,10c0-1.72925.61047-3.31738,1.62463-4.56482l10.19019,10.19019c-1.24744,1.01416-2.83563,1.62463-4.56482,1.62463-3.99756,0-7.25-3.25244-7.25-7.25Z"
      fill="currentColor"
    />
  </svg>`;
};
